"use client";

import { useTenant } from "@tillix/tenants/react";
import { BaseForm, type BaseFormProps } from "./form";

export function Form(props: BaseFormProps) {
  const contextTenant = useTenant();

  const tenantRefId = props.tenant?.id ?? contextTenant?.id;

  switch (tenantRefId) {
    default:
      return <BaseForm {...props} />;
  }
}
